/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {getServiceT001, putServiceT001} from '../../core/prestation/request'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../../../auth'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {Button, Modal} from 'react-bootstrap'
import * as lodash from 'lodash'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {ListeServiceStatus} from '../../core/prestation/model'
import {Color} from '../../../../../common/components/Constants/colors.constants'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

const initialTBForm1Values = {
  Disassembly: null,
  Protection: null,
}

type ToggleButtonForm1Props = {
  isVisible: boolean
  onDetectChange1?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t001?: ListeServiceStatus
}

const ToggleButtonForm1: FC<ToggleButtonForm1Props> = ({
  isVisible,
  onDetectChange1,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  loadListServiceStatus,
  onSavedForm,
  t001,
}) => {
  console.log(t001)

  const intl = useIntl()
  const {pGuid} = useParams()
  const {setAuthMessage, logout} = useAuth()
  const projectData = useSelector((state: any) => state.projectData)
  const [serviceT001, setServiceT001] = useState<any>(null)
  const [t1init, setT1init] = useState<any>(initialTBForm1Values)
  const {mode} = useThemeMode()
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)

  async function loadServiceT001() {
    const response = await getServiceT001(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT001(response?.data?.data)
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadServiceT001()
  }, [])

  const handleClickT001 = async () => {
    try {
      const dataToUpdate = {
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
        Disassembly: serviceT001?.Disassembly,
        Protection: serviceT001?.Protection,
      }
      const response = await putServiceT001(dataToUpdate)
      if (response.data.Status.Success) {
        if (onSavedForm) {
          onSavedForm(true)
        }
        if (loadListServiceStatus) {
          await loadListServiceStatus()
        }
      }
      await loadServiceT001()
    } catch (error) {
      console.error('Erreur lors de la sauvegarde :', error)
    }
  }
  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadServiceT001()
      setShowCancel(false)
    } else {
      setServiceT001(t1init)
      setShowCancel(false)
    }
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT001, t1init)
  }, [serviceT001, t1init])

  useEffect(() => {
    if (onDetectChange1) {
      onDetectChange1(isDisabled)
    }
  }, [isDisabled, onDetectChange1])

  return (
    <div>
      {isVisible && (
        <div className='p-5 mt-8'>
          <form>
            <div className='d-flex justify-content-between'>
              <div>
                <label className='fs-4 fw-bold text-gray-700 mb-5'>
                  {intl.formatMessage({id: 'SHOULD.WE.PLAN.FOR.WORKSHOP.PREPARATION'})}
                </label>
              </div>
              <div>{/*<CenterHelp />*/}</div>
            </div>

            <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column'>
              <span className='fs-5 text-gray-700' style={{flex: 0.6}}>
                {intl.formatMessage({id: 'DISASSEMBLY.INTO.PARTS'})}
              </span>
              <div className='d-flex gap-10' style={{flex: 0.4}}>
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'YES'})}
                  checked={serviceT001?.Disassembly === true}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    setServiceT001({...serviceT001, Disassembly: true})
                  }}
                />
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'NO'})}
                  checked={serviceT001?.Disassembly === false}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    setServiceT001({...serviceT001, Disassembly: false})
                  }}
                />
              </div>
            </div>
            <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'>
              <label className='fs-5 text-gray-700' style={{flex: 0.6}}>
                {intl.formatMessage({id: 'SPECIFIC.PROTECTION'})}{' '}
              </label>
              <div className='d-flex gap-10' style={{flex: 0.4}}>
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'YES'})}
                  checked={serviceT001?.Protection === true}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    setServiceT001({...serviceT001, Protection: true})
                  }}
                />
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'NO'})}
                  checked={serviceT001?.Protection === false}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    setServiceT001({...serviceT001, Protection: false})
                  }}
                />
              </div>
            </div>

            {!Submitted && (
              <div className='d-flex gap-5 justify-content-end my-5'>
                <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                  <Button
                    className='btn btn-dark'
                    disabled={isDisabled}
                    onClick={() => {
                      if (!lodash.isEqual(serviceT001, t1init)) {
                        // TODO show modal confirmation
                        setShowCancel(true)
                      } else {
                        setServiceT001({...t1init})
                      }
                    }}
                  >
                    {intl.formatMessage({id: 'RESET'})}
                    <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                  </Button>
                </span>
                <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                  <Button
                    type='button'
                    className='btn btn-danger'
                    disabled={isDisabled}
                    onClick={handleClickT001}
                    style={{
                      backgroundColor: mode === 'dark' ? Color.BG_DARK : Color.BG_LIGHT,
                    }}
                  >
                    {intl.formatMessage({id: 'SAVE'})}
                    <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                  </Button>
                </span>
              </div>
            )}
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToggleButtonForm1
